import { CanDeactivateFn, Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { SOFTLINE_FILTER_WWS_DELIVERY_NOTE_CORRECTION } from './delivery-note-correction.api';
import {
  SOFTLINE_PERMISSION_WWS_DELIVERY_NOTE_CORRECTION,
  SOFTLINE_ROUTE_WWS_DELIVERY_NOTE_CORRECTION,
} from './delivery-note-correction.shared';
import { DeliveryNoteDocumentRepository } from './repositories/delivery-note-document.repository';
import { DeliveryNoteQueryDataSource } from './repositories/delivery-note-query.data-source';
import { TextSuggestionRepository } from './repositories/text-suggestion.repository';
import { DeliveryNoteDeletionService } from './services/delivery-note-deletion.service';
import { CommissioningStagesService } from './services/commissioning-stages.service';
import { DocumentIconsService } from './services/document-icons.service';
import { TextSuggestionService } from './services/text-suggestion.service';
import { deliveryNoteCorrectionFilter } from './types/delivery-note-query.filter';
import type { CorrectPage } from './pages/correct/correct.page';

const confirmCorrectionLeave: CanDeactivateFn<CorrectPage> = (component) =>
  component.confirmLeave();

export const deliveryNoteCorrectionRoutes: Routes = [
  {
    path: SOFTLINE_ROUTE_WWS_DELIVERY_NOTE_CORRECTION,
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_WWS_DELIVERY_NOTE_CORRECTION },
    providers: [
      DocumentIconsService,
      CommissioningStagesService,
      TextSuggestionRepository,
      TextSuggestionService,
      DeliveryNoteDocumentRepository,
      DeliveryNoteDeletionService,
      DeliveryNoteQueryDataSource,
      {
        provide: SOFTLINE_FILTER_WWS_DELIVERY_NOTE_CORRECTION,
        useFactory: () => deliveryNoteCorrectionFilter(),
      },
    ],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'overview' },
      {
        path: 'overview',
        loadComponent: () =>
          import('./pages/overview/overview.page').then((o) => o.OverviewPage),
      },
      {
        path: 'correct/:documentId',
        canDeactivate: [confirmCorrectionLeave],
        loadComponent: () =>
          import('./pages/correct/correct.page').then((o) => o.CorrectPage),
      },
    ],
  },
];
